import * as React from 'react';
export default class NotFound extends React.PureComponent {
  render() {
    return <div style={{ textAlign: 'center' }}>
      <h1>Không tìm thấy trang</h1>
    </div>;
  }
}